import setIcd10Codes from './setIcd10Codes';
import setMoreIcd10Codes from './setMoreIcd10Codes';
import reset from './reset';
import addIcd10Codes from './addIcd10Codes';
import updateIcd10Code from './updateIcd10Code';
import removeIcd10Code from './removeIcd10Code';

export default {
  setIcd10Codes,
  setMoreIcd10Codes,
  reset,
  addIcd10Codes,
  updateIcd10Code,
  removeIcd10Code,
};
